import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getMarketplaceMe } from '../../api/marketplace';

// Slim shell for marketplace firm users. It deliberately has no links to cases,
// support, the Finanças queue or referrals: those areas are for Coepi staff and
// referral partners only.
const MarketplaceLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { currentUser, logout } = useAuth();
  const [firmName, setFirmName] = useState('');

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      if (!currentUser) return;
      try {
        const token = await currentUser.getIdToken();
        const me = await getMarketplaceMe(token);
        if (!cancelled) setFirmName(me?.firm?.name || '');
      } catch {
        // The header works without the firm name; the pages surface errors.
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [currentUser]);

  return (
    <div className="coepi-container marketplace-shell">
      <header className="coepi-header">
        <div className="logo">
          coepi <span className="marketplace-logo-suffix">marketplace</span>
        </div>
        <div className="user-profile">
          {firmName && (
            <span className="marketplace-firm-name" data-testid="marketplace-firm-name">
              {firmName}
            </span>
          )}
          <span>{currentUser?.email}</span>
          <button onClick={logout} className="logout-button">Sign Out</button>
        </div>
      </header>
      <main className="coepi-main">
        <aside className="sidebar">
          <nav className="task-nav" aria-label="Marketplace">
            <ul>
              <li><Link to="/marketplace">Marketplace board</Link></li>
              <li><Link to="/marketplace/my-work">My work</Link></li>
            </ul>
          </nav>
        </aside>
        <section className="task-view">{children}</section>
      </main>
    </div>
  );
};

export default MarketplaceLayout;
